import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateRecordLabel, AttachToRecordLabelSuccess, RemoveFromRecordLabelSuccess } from '../action-creators';
import { ATTACH_TO_RECORD_LABEL_SUCCESS, REMOVE_FROM_RECORD_LABEL_SUCCESS } from '../actions';
import AppState from '../../state';
import { NoOp } from '@webapp/store/ui/action-creators';
import { RecordLabel } from '@common/types/record-label/record-label';


export const updateArtistCountEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, AttachToRecordLabelSuccess | RemoveFromRecordLabelSuccess>(
      ATTACH_TO_RECORD_LABEL_SUCCESS,
      REMOVE_FROM_RECORD_LABEL_SUCCESS
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const recordLabel = state.recordLabels.list.find((r) => r.id === action.relation.recordLabelId);

      if (!recordLabel) {
        return new NoOp();
      }

      const artistCount = state.recordLabels.artists[recordLabel.id]?.length || 0;

      const updated: RecordLabel = {
        ...recordLabel,
        artistCount
      }

      return new UpdateRecordLabel(updated)
    })
  );